export default __webpack_public_path__ + "static/media/Custom_Home.f589a42e.png";